import classNames from 'classnames';

import { IcDeleteIcon } from '@gem/icons';
import { IconButton, popupItemStyles } from '@gem/ui-kit';

import { AvatarTypes } from 'APP/components/Avatar/Avatar';
import { PopupInfoCard } from 'APP/components/PopupInfoCard/PopupInfoCard';

import styles from './style.m.scss';

const User = ({ user, ignoreIsMe }) => {
  const containerProps = classNames(popupItemStyles.container);

  return (
    <div className={containerProps}>
      <PopupInfoCard
        type={AvatarTypes.Round_10}
        className={popupItemStyles.card}
        avatarTitle={user.avatarTitle}
        avatarUrl={user.avatarUrl}
        avatarBackgroundColorIndex={user.avatarBackgroundColorIndex}
        title={user.title}
        subtitle={user.subtitle}
      />
      {user.isMe && !ignoreIsMe && (
        <IconButton
          onClick={user.onDelete}
          iconClassName={styles.icon}
          Icon={IcDeleteIcon}
        />
      )}
    </div>
  );
};

export default User;
